import { useEffect } from "react";
import { _EmployeeDossier, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import useDataBean from "../../../../../core/services/dataBean/useDataBean"
import { BasicTable, MASK_DATE, MASK_NUMBER } from "../../../../theme/Component/BasicTable";
import { FileInput } from "../../../../theme/Component/FileInput";
import useModal, { MODAL_LG, MODAL_md, MODAL_SM } from "../../../../theme/Component/hooks/useModal";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { Modal } from "../../../../theme/Component/Modal";
import usePaginator from "../../../../theme/Component/usePaginator";
import { isValid } from "date-fns";
import { toast } from "react-toastify";
import { PrintJson } from "../../../../theme/Component/PrintJson";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { FileService } from "../../../../../core/services/FileService";

interface Props {
    idAccount: number;
}
export const EmployeeDossier = ({ idAccount }: Props) => {

    const _employeeDossier = useDataBean(_EmployeeDossier);
    const fileService = new FileService();
    const { bean, setBean, lista, setLista, handleChange, addRequiredFields, isRequired, validate } = _employeeDossier;
    const modalEdit = useModal("Editar", MODAL_md);
    const modalDel = useModal("Eliminar", MODAL_SM);

    const paginador = usePaginator();
    const types = [
        { id: 100, name: "HOJA DE VIDA" },
        { id: 101, name: "CERTIFICACIÓN" },
        { id: 102, name: "REFERENCIA" },
        { id: 103, name: "DIPLOMA" },
        { id: 104, name: "ANEXO" },
    ]
    const head = [
        { title: 'No', property: 'IDEmployeeDossier', mask: MASK_NUMBER, visible: false },
        { title: 'Tipo Documento', property: 'DocTypeName' },
        { title: 'Archivo', property: 'FileName' },
        { title: 'Ver', property: 'URL' },
        { title: 'Fecha', property: 'Since' },
    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: _single.canCreate(), icono: 'ri-file-add-line', evento: () => { addItem() } }
    ]
    const listaBotones = () => {
        const botones = [
            { titulo: 'Editar', icono: 'ri-file-list-line', visible: _single.canEdit(), evento: () => { modalEdit.open() } },
            { titulo: 'Eliminar', icono: 'ri-file-user-line', visible: _single.canDelete(), evento: () => { modalDel.open() } },
        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }

    useEffect(() => {
        addRequiredFields(["IDDocType", "Media", "MediaContext", "FileName"]);
        getEmployeeDossierList();
    }, [])

    const addItem = () => {
        setBean({
            IDAccount: idAccount,
            State: 1,
            IDEmployee: _single.getAccountID(),
            IDDocType: 100
        });
        modalEdit.open();
    }
    const edit = () => {
        if (!validate()) {
            toast.error("Faltan campos obligatorios");
        }

        _employeeDossier.updateCustonBean(bean).then(
            (resp: any) => {
                getEmployeeDossierList();
                modalEdit.close();
            }
        )
    }
    const getEmployeeDossierList = () => {
        const filter = {
            IDAccount: idAccount,
            State: 1
        }
        
        _employeeDossier.instance.getEmployeeDossierRender(paginador.page, 15, filter).then(
            (resp: any) => {
                if(resp.List)
                {
                    resp.List.forEach(element => {
                            element.DataBeanProperties.URL = "<a href="+
                            fileService.getUrlFile(
                                element.DataBeanProperties.MediaContext,
                                element.DataBeanProperties.Media
                            )
                            +" target='blank'>Ver</a>"
                    });
                }
                setLista(resp.List);
                paginador.setPages(resp.NumberOfPages);
            }
        )
    }
    const delItem = () => {
        _employeeDossier.updateCustonBean({ ...bean, State: 2 }).then(
            (resp: any) => {
                getEmployeeDossierList();
                modalDel.close();
            }
        )
    }

    return (
        <div className="row">
            <div className="col-md-12">
                <BasicTable
                    body={lista}
                    head={head}
                    rowSet={setBean}
                    iconButtons={iconButtonsItem}
                    listButtons={listaBotones()}
                    records={paginador}></BasicTable>
                <Modal modal={modalEdit.modal} updateModal={modalEdit.setModal} eventModal={edit}>
                    <div className="row">
                        <div className="col-md-6">
                            <label>Tipo Documento</label>
                            <select name="IDDocType" className="form-select" value={bean.IDDocType} onChange={handleChange}>
                                {types.map((item) => {
                                    return (
                                        <option value={item.id}>{item.name}</option>
                                    )
                                })}
                            </select>
                        </div>
                        <div className="col-md-6">
                            <FileInput directory="employeedossier"
                                Media={bean.Media} MediaContext={bean.MediaContext}
                                onCreate={(e) => { setBean({ ...bean, Media: e.Media, MediaContext: e.MediaContext, FileName: e.Name }); console.log(e) }}
                            />
                        </div>
                    </div>
                </Modal>
                <ModalConfirm modal={modalDel.modal} updateModal={modalDel.setModal} eventModal={delItem}>
                    <div className="row">
                        <div className="col-md-12">
                            Eliminar registro ?
                        </div>
                    </div>
                </ModalConfirm>
            </div>
            <div className="col-md-12">
                {/* <PrintJson json={lista} /> */}
            </div>
        </div>
    )
}